module.exports = __webpack_public_path__ + "img/piaget-altiplano-ultimate-910p-2.ef4f8e0f.png";